/* istanbul ignore file */
/* eslint-disable security/detect-object-injection */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApplicationContext from '../../../../../context/ApplicationContext';
import Input from '../../../../../components/Input';
import { documentsLanguageContent } from '../../../documentsLanguageContent';

function DigitalSignature(props) {
    const { sessionData, selectedLanguage } = useContext(ApplicationContext);
    const { signatureState, setSignatureState, signatureType } = props;
    const digitalCanvasRef = useRef();
    const [selectedFont, setSelectedFont] = useState('Times New Roman, serif');
    const [show, setShow] = useState(false);
    const [selectedFontClass, setSelectedFontClass] = useState('times-new-roman');

    const fontFamily = [{
        value: "'Alex Brush', cursive",
        class: 'alex-brush',
    },
    {
        value: "'Great Vibes', cursive",
        class: 'great-vibes-cursive'
    },
    {
        value: "'Herr Von Muellerhoff', cursive",
        class: 'herr-von-muellerhoff'
    }
    ]

    const loadSignatureData = () => {
        setSelectedFont(sessionData?.signature_session?.selected_font || "'Alex Brush', cursive");
        setSelectedFontClass(sessionData?.signature_session?.selected_font_class || 'alex-brush');
        setSignatureState({
            user_name: sessionData?.patient_details?.signature_user_initials || '',
            user_initials: sessionData?.patient_details?.signature_username || ''
        })
    };
    
    const handleSaveSignature = async (item) => {
        setSelectedFont(item.value);
        setSelectedFontClass(item.class);
        setSignatureState((prev) => ({
            ...prev,
            'selected_font': item.value,
            'selected_font_class': item.class
        }))
        setShow(false);
    }

    useEffect(() => {
        loadSignatureData();
    }, [sessionData]);
    
    return (
        <div className={`relative px-[20px] mt-[40px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
            <canvas
                className={`rounded-b bg-[#D7D7D7] hidden`}
                ref={digitalCanvasRef}
                id={`digitalCanvas`}
                width={1030}
                height={70}
                // value={selectedComponent.value}
            ></canvas>
            <div className="relative">
                <Input maxChar={64} handleRegex={false} setSubmitSelected={null} message="" setMessage={null} disabled={Object.keys(sessionData.signature_session).length > 0}
                    submitSelected={null} id="user_name" value={signatureState.user_name} placeholder={documentsLanguageContent['user-name-placeholder'][selectedLanguage]}
                    setState={setSignatureState} labelName={documentsLanguageContent['user-name'][selectedLanguage]} isMandatory={false}  />
            </div>
            <div className='relative w-full flex mt-[14px] gap-[8px] items-end'>
                <div className="relative w-[32%]">
                    <Input handleRegex={true} setSubmitSelected={null} message="" setMessage={null} regex={/[^a-zA-Z]+$/} className="uppercase"
                        submitSelected={null} id="user_initials" value={signatureState.user_initials} placeholder={documentsLanguageContent['initials-placeholder'][selectedLanguage]}  disabled={Object.keys(sessionData.signature_session).length > 0}
                        setState={setSignatureState} labelName={documentsLanguageContent['user-initials'][selectedLanguage]} isMandatory={false} maxChar={5}  />
                </div>
                <div className='relative w-[68%] h-[40px]'>
                    <button disabled={Object.keys(sessionData.signature_session).length > 0} onClick={() => {Object.keys(sessionData.signature_session).length > 0 ? '' : setShow(!show)}} 
                        type="button" className={`text-[#333] font-normal px-[12px] text-sm w-full h-full bg-[#025478] rounded flex justify-between items-center ${Object.keys(sessionData.signature_session).length > 0 ? 'pointer-events-none' : ''}`} data-testid="font-family">
                        <p className={`text-sm font-normal text-[#F2F2F2]`}>
                            {documentsLanguageContent['font'][selectedLanguage]}:
                        </p>
                        <p data-testid={`selected-signature`} className={`dropdown-item ${selectedFontClass} text-base text-[#F2F2F2] capitalize text-truncate`}>
                            {signatureState.user_name || 'Signature'}
                        </p>
                        <img src="/images/down.svg" alt="arrow" className='ml-2' />
                    </button>
                    <ul style={{inset: '-140px auto auto auto'}}
                        id="font-family" className={`rounded-lg border border-[#797979] w-full bg-[#F2F2F2] dropdown-menu absolute m-0 shadow-blue z-[9999] left-0 hidden max-h-[212px] 
                    p-2 ${show === true ? 'show' : ''}`}
                        aria-labelledby="font-family">
                        <div className='overflow-y-auto Form-scroll'>
                            {fontFamily.map((item, index) => (
                                <li key={index} className="automatic rounded-lg p-2 cursor-pointer" onClick={(e) => {handleSaveSignature(item)}}>
                                    <p data-testid={`font-family-${index}`} className={`dropdown-item ${item.class} text-base ${item.class === selectedFontClass ? 'text-[#007EB4]' : 'text-[#333]'} capitalize text-truncate`}>
                                        {signatureState.user_name || 'Signature'}
                                    </p>
                                </li>
                            ))}
                        </div>
                    </ul>
                    <div className={['filter-overlay cursor-pointer ', show === true ? 'filter-open ' : ''].join('')} onClick={() => setShow(false)} />
                </div>
            </div>
        </div>
    );
}

export default DigitalSignature;
